// src/utils/blogs.js
import axios from './axios';

// Get all blogs
export const getAllBlogs = () => {
  return axios.get('/blogs');
};

// Get a blog by ID
export const getBlogById = (id) => {
  return axios.get(`/blogs/${id}`);
};

// Get blogs by slug
export const getBlogsBySlug = (slug) => {
  return axios.get(`/blogs/slug/${slug}`);
};

// Get most liked blogs
export const getMostLikedBlogs = () => {
  return axios.get('/blogs-most-liked');
};

// Create a new blog
export const createBlog = (blogData) => {
  return axios.post('/blogs', blogData);
};

// Update a blog
export const updateBlog = (id, blogData) => {
  return axios.put(`/blogs/${id}`, blogData);
};

// Delete a blog
export const deleteBlog = (id) => {
  return axios.delete(`/blogs/${id}`);
};